import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template", "entry", "status"]

  add() {
    const fragment = this.templateTarget.content.cloneNode(true)
    const entry = fragment.querySelector("li")
    this.pendingFocusEntry = entry
    this.listTarget.append(fragment)
    this.focusEntryWhenReady(entry)
    this.statusTarget.textContent = "Set added. Changes are not saved yet."
  }

  remove(event) {
    const entry = event.target.closest("li")
    const next = entry.nextElementSibling || entry.previousElementSibling
    entry.remove()
    if (next) this.focusEntryWhenReady(next)
    else this.addButton.focus()
    this.statusTarget.textContent = "Set removed. Changes are not saved yet."
  }

  up(event) { this.move(event, -1) }
  down(event) { this.move(event, 1) }

  move(event, direction) {
    const entry = event.target.closest("li")
    const neighbor = direction < 0 ? entry.previousElementSibling : entry.nextElementSibling
    if (!neighbor) return
    if (direction < 0) neighbor.before(entry)
    else neighbor.after(entry)
    event.target.focus()
    this.statusTarget.textContent = `Set moved to position ${this.entryTargets.indexOf(entry) + 1}. Changes are not saved yet.`
  }

  ready(event) {
    const entry = event.target.closest("li")
    if (entry && entry === this.pendingFocusEntry) {
      this.focusEntry(entry)
      this.pendingFocusEntry = null
    }
  }

  focusEntryWhenReady(entry) {
    if (!entry) return

    if (!this.focusEntry(entry)) {
      this.pendingFocusEntry = entry
    }
  }

  focusEntry(entry) {
    const select = entry.querySelector("select")
    if (select?.tomselect) {
      select.tomselect.focus()
      return true
    }

    const control = entry.querySelector(".ts-control input") || select
    if (!control) return false

    control.focus()
    return true
  }

  get addButton() {
    return this.element.querySelector('[data-action="preview-focus-sets#add"]')
  }
}
